import React, { Component } from 'react';
import IgniteDataTable from '../../../common/datatable';
import { history } from '../../../../store';

class GamesTable extends Component {
  handleEdit = (row) => {
    history.push(`/admin/games/${row.id}/edit`);
  }

  render() {
    const { games } = this.props;
    const columns = [
      { prop: "name", title: "Name" }
    ];
    const actions = [
      {
        label: 'Edit',
        callback: this.handleEdit
      }
    ];

    return (
      <IgniteDataTable
        data={games}
        columns={columns}
        actions={actions}
      />
    );
  }  
}

export default GamesTable;



// WEBPACK FOOTER //
// ./src/components/admin/games/list/games-table.jsx